import { HttpContextToken } from '@angular/common/http';

/** When true, LoadingInterceptor does not toggle the global loader for this request. */
export const SKIP_LOADER = new HttpContextToken<boolean>(() => false);

export const SKIP_LOADER_HEADER = 'X-Skip-Loader';
